// hooks/useImagesData.js
import { useState, useEffect, useMemo } from 'react';
import { enrichImagesData } from '../utils/enrichImageData';
import { shuffleArray } from '../utils/arrayUtils';
import { useColorMapping } from './useColorMapping';

// ✅ IMPORT DIRECT DU JSON depuis src/data/
// Assurez-vous que le fichier existe dans : src/data/domodata.json
import rawJsonData from '../data/domo.json';

/**
 * Hook pour charger et enrichir les données d'images
 * Les calculs d'enrichissement sont faits UNE SEULE FOIS au chargement
 * 
 * @returns {Array} Tableau d'images enrichies avec toutes les données calculées
 */
export const useImagesData = () => {
  const [rawImages, setRawImages] = useState([]);
  const [rawPeriods, setRawPeriods] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Charger les données brutes - SYNCHRONE (pas besoin de fetch)
  useEffect(() => {
    try {
      // 🔹 Utilisation directe des données importées
      // Le JSON est déjà chargé via l'import en haut du fichier
      setRawImages(shuffleArray(rawJsonData.img));
      setRawPeriods(rawJsonData.periods);
      setLoading(false);
      
    } catch (error) {
      console.error('Erreur chargement images:', error);
      setRawImages([]);
      setRawPeriods([]);
      setLoading(false);
    }
  }, []);
  
  // ✅ Obtenir le mapping des couleurs
  const uniqueTypolos = useMemo(() => {
    if (!rawImages.length) return [];
    
    const typolos = new Set();
    rawImages.forEach(img => {
      if (img.typoloA) {
        // Extraire le tag principal (avant le underscore)
        const mainTag = img.typoloA.split('_')[0];
        typolos.add(mainTag);
      }
    });
    
    return Array.from(typolos);
  }, [rawImages]);

  const colorMap = useColorMapping(uniqueTypolos);
  
  // ✅ ENRICHISSEMENT - Fait UNE SEULE FOIS quand rawImages ou colorMap changent
  const enrichedImages = useMemo(() => {
    if (loading || !rawImages.length || !Object.keys(colorMap).length) {
      return [];
    }

    /*console.log('🎨 Enrichissement des images...', {
      count: rawImages.length,
      colorMapKeys: Object.keys(colorMap).length
    });*/

    return enrichImagesData(rawImages, colorMap);
  }, [rawImages, colorMap, loading]);

  return { 
    images: enrichedImages, 
    loading,
    periods: rawPeriods,
  };
};